module.exports = __webpack_public_path__ + "img/ring_skip_skip_null_1.bea7b7eb.png";